import Vue from 'vue';
import './common/global';
import './common/lang';
import {store} from './account/store';
import PaymentMethods from './payments/components/PaymentMethods';
import InvoiceSummary from './account/components/InvoiceSummary';
import MessageBlock from './account/components/MessageBlock';
import PayBtn from './account/components/PayBtn';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
import {mapFields} from "vuex-map-fields";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Install BootstrapVue
Vue.use(BootstrapVue);

import {filters} from './common/filters.js';
Vue.filter('priceFormat', filters.priceFormat);
Vue.filter('withCurrency', filters.withCurrency);

if (document.getElementById('account-payment')) {
    new Vue({
        el        : '#account-payment',
        store,
        data      : {},
        computed  : {
            ...mapFields([
                'reference'
            ]),
        },
        methods   : {
            createPaymentIntent() {
                this.$refs.paymentMethods.$children.map(function (component) {
                    if(component.isActive){
                        component.$children[0].createPaymentIntent()
                    }
                })
            },
            successBooking() {
                window.location.href = window.success_page;
            },
        },
        components: {
            PaymentMethods,
            PayBtn,
            InvoiceSummary,
            MessageBlock,
        }
    });
}




